(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nana-base"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nana-scroller')) {
    class NanaScroller extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-nana-track]');
        if (!this.track) return;
        this.prevButton = this.querySelector('[data-nana-prev]');
        this.nextButton = this.querySelector('[data-nana-next]');
        this.progress = this.querySelector('[data-nana-progress]');
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.prevButton?.addEventListener('click', () => this.step(-1), { signal });
        this.nextButton?.addEventListener('click', () => this.step(1), { signal });
        this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
      }

      step(direction) {
        const item = this.track.firstElementChild;
        if (!item) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const isRtl = getComputedStyle(this.track).direction === 'rtl';
        const distance = (item.getBoundingClientRect().width + gap) * direction * (isRtl ? -1 : 1);
        this.track.scrollBy({ left: distance, behavior: 'smooth' });
      }

      update() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        if (this.prevButton) this.prevButton.disabled = position <= 2;
        if (this.nextButton) this.nextButton.disabled = position >= maxScroll - 2;
        if (this.progress) {
          const visible = maxScroll > 0 ? this.track.clientWidth / this.track.scrollWidth : 1;
          const ratio = maxScroll > 0 ? position / maxScroll : 0;
          this.progress.style.setProperty('--nana-progress-size', `${visible * 100}%`);
          this.progress.style.setProperty('--nana-progress-offset', `${ratio * (1 / visible - 1) * 100}%`);
        }
      }
    }

    customElements.define('nana-scroller', NanaScroller);
  }

  document.addEventListener('change', (event) => {
    const field = event.target.closest?.('[data-nana-autosubmit]');
    if (field?.form) field.form.requestSubmit ? field.form.requestSubmit() : field.form.submit();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nana-header-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const menu = document.querySelector('[data-nana-header-menu]');
    const burger = document.querySelector('[data-nana-burger]');
    const veil = document.querySelector('[data-nana-header-veil]');
    const bar = document.querySelector('#header-component');
    if (!menu || !burger || !bar) return;

    const isOpen = () => menu.dataset.open === 'true';

    const toggle = (open) => {
      menu.dataset.open = String(open);
      menu.inert = !open;
      burger.setAttribute('aria-expanded', String(open));
      veil?.classList.toggle('is-active', open);
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) menu.querySelector('a')?.focus({ preventScroll: true });
      else burger.focus({ preventScroll: true });
    };

    burger.addEventListener('click', () => toggle(!isOpen()));
    veil?.addEventListener('click', () => toggle(false));
    menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) toggle(false);
    });

    document.addEventListener('keydown', (event) => {
      if (!isOpen()) return;
      if (event.key === 'Escape') {
        toggle(false);
        return;
      }
      if (event.key !== 'Tab') return;
      // Le focus reste dans la barre tant que le menu est ouvert
      const focusable = Array.from(bar.querySelectorAll('a[href], button')).filter((element) => element.offsetParent);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.matchMedia('(min-width: 750px)').addEventListener('change', (event) => {
      if (event.matches && isOpen()) toggle(false);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
